export class BaseStudy {
  studyId: number;
}
